<!-- TODO - no title? -->

<mat-dialog-content>
    <mat-card>
        <info-table fxFlex [criteria]="criteria" [displayHeader]="displayHeader" [displayTable]="displayTable"
                    [ignoreNumbers]="ignoreNumbers" [noFilter]="noFilter" [rowsPerPage]="rowsPerPage"
                    [(tableData)]="tableData" (clientAction)="clientAction($event)">
        </info-table>
    </mat-card>
</mat-dialog-content>

<mat-dialog-actions fxLayoutAlign="end center">
    <button mat-button (click)="onCloseClicked()" telemetry="Submission-InfoTableClose">
        Close
    </button>
</mat-dialog-actions>